module.exports = __webpack_public_path__ + "20250828d091945t/img/learning-cuate-icon2.d4c465b4.png";